// Aluume brandmark (the angular "A" symbol) — vendored from the brand SVG
// (Figma RGB_Brandmark). Uses `currentColor` so it inherits the surrounding
// text colour (cream on the dark site header).
export function AluumeMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 57 54"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path d="M47.0662 4.8859H36.6141C35.0592 4.8859 33.6791 5.883 33.1972 7.35916C33.1223 7.58841 33.0468 7.81765 32.9697 8.04638C32.0609 10.8206 31.0349 13.5605 29.9002 16.2435C29.3307 17.5937 27.2391 22.4084 24.1738 27.8229C20.0999 35.0171 14.9562 42.1592 8.84714 49.1146H13.4341C18.8427 42.7062 23.4518 36.146 27.1996 29.5294C30.2739 24.1112 32.3517 19.3744 33.1043 17.5942C34.4217 14.4769 35.6002 11.2812 36.6304 8.0469H44.9872V44.117H48.1529V5.97101C48.1529 5.3718 47.6662 4.88538 47.0656 4.88538L47.0662 4.8859Z" />
    </svg>
  );
}
